import { SEMVER_PATTERN } from "@/features/servers/schemas/servers";

/** Parsea "mayor.menor.patch" → tupla numérica. */
export function parseSemver(
  version: string | undefined
): [number, number, number] | null {
  if (!version) return null;
  const trimmed = version.trim();
  if (!SEMVER_PATTERN.test(trimmed)) return null;
  const [a, b, c] = trimmed.split(".").map((n) => Number.parseInt(n, 10));
  if ([a, b, c].some((n) => !Number.isFinite(n))) return null;
  return [a, b, c];
}

/**
 * Compara dos versiones 0.0.0.
 * @returns negativo si a < b, 0 si iguales, positivo si a > b; null si inválidas.
 */
export function compareSemver(
  a: string | undefined,
  b: string | undefined
): number | null {
  const pa = parseSemver(a);
  const pb = parseSemver(b);
  if (!pa || !pb) return null;
  for (let i = 0; i < 3; i++) {
    if (pa[i] !== pb[i]) return pa[i] - pb[i];
  }
  return 0;
}

/**
 * True si la versión instalada es menor que la objetivo (o no se puede comparar).
 * Sin target configurado → no se considera desactualizado.
 */
export function isVersionOutdated(
  installed: string | undefined,
  target: string | undefined
): boolean {
  if (!target?.trim()) return false;
  const cmp = compareSemver(installed, target);
  if (cmp === null) return true;
  return cmp < 0;
}

/** Normaliza input a 0.0.0 o string vacío. */
export function normalizeSemverInput(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";
  return SEMVER_PATTERN.test(trimmed) ? trimmed : trimmed;
}
